import classNames from 'classnames';
import * as React from 'react';
import { List } from '../List/List';
import type { PictureProps } from '../Picture/Picture';
import { Picture } from '../Picture/Picture';
import type { IconName } from '../SvgIcon/SvgIcon';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import type { LetterLocation } from '~/Blocks/HeroLegacy/LetterLocation.csharp';
import styles from './EmployeeCard.module.css';

export interface EmployeeCardProps {
    firstName: string;
    lastName: string;
    jobTitles: string[];
    linkUrl: string;
    letterLocation?: LetterLocation;
    picture?: PictureProps;
}

export const EmployeeCard: React.FC<React.PropsWithChildren<EmployeeCardProps>> = React.memo(props => {
    const { firstName, lastName, jobTitles, linkUrl, picture, letterLocation } = props;

    return (
        <a
            href={linkUrl}
            className={classNames(styles.EmployeeCard, letterLocation && styles[`Variant--${letterLocation}Letter`])}
            aria-label={`${firstName} ${lastName}, ${jobTitles}`}
        >
            <div className={styles.Image}>
                {picture && <Picture {...picture} />}
                {firstName && (
                    <SvgIcon className={styles.IconFirstName} iconName={firstName[0].toLowerCase() as IconName} />
                )}
                {lastName && (
                    <SvgIcon className={styles.IconLastName} iconName={lastName[0].toLowerCase() as IconName} />
                )}
            </div>
            <div className={styles.Content}>
                <h3 className={styles.Heading}>
                    {firstName} {lastName}
                </h3>

                {jobTitles && (
                    <div className={styles.Details}>
                        <List
                            className={styles.JobTitles}
                            items={jobTitles}
                            renderItem={item => (
                                <li className={styles.JobTitle} key={item}>
                                    {item}
                                </li>
                            )}
                        />
                    </div>
                )}
            </div>
        </a>
    );
});
